var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgAudioOn = function SvgAudioOn(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "inherit"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.36 24.21c-.48 0-.94-.19-1.29-.55l-3.94-3.94H10a1.225 1.225 0 0 1-1.23-1.23v-5A1.225 1.225 0 0 1 10 12.26h4.13l3.94-3.94c.54-.54 1.31-.7 2.02-.4.7.29 1.14.95 1.14 1.71v12.72c0 .76-.44 1.42-1.14 1.71-.24.1-.49.15-.73.15M10 13.48l-.02.02v5l4.4.03c.16 0 .31.06.42.18l4.12 4.12c.29.29.62.18.71.14s.4-.2.4-.6V9.64c0-.4-.31-.56-.4-.6a.65.65 0 0 0-.71.14L14.8 13.3c-.11.11-.27.18-.42.18z"
  })));
};
export default SvgAudioOn;